module.exports = "/resources/assets/prod/4b7f305bd2b68a0fa56fb6aacb4004a0.svg";